import { render } from "./AboutStablePower.vue?vue&type=template&id=8ee7200c&ts=true"
import script from "./AboutStablePower.vue?vue&type=script&lang=ts"
export * from "./AboutStablePower.vue?vue&type=script&lang=ts"

import "./AboutStablePower.vue?vue&type=style&index=0&id=8ee7200c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__